import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RadiusSelectorProps {
  value: number;
  onChange: (radius: number) => void;
  disabled?: boolean;
}

const radiusOptions = [
  { value: 100, label: "100 miles" },
  { value: 200, label: "200 miles" },
  { value: 300, label: "300 miles" },
  { value: 400, label: "400 miles" },
  { value: 500, label: "500 miles" },
];

export const RadiusSelector = ({ value, onChange, disabled }: RadiusSelectorProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="radius">Search Radius</Label>
      <Select
        value={value.toString()}
        onValueChange={(val) => onChange(parseInt(val, 10))}
        disabled={disabled}
      >
        <SelectTrigger id="radius" className="w-full">
          <SelectValue placeholder="Select radius" />
        </SelectTrigger>
        <SelectContent>
          {radiusOptions.map((option) => (
            <SelectItem key={option.value} value={option.value.toString()}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        See activity within this distance from your home location
      </p>
    </div>
  );
};
